
import React from 'react';
import AchievementsSection from '@/components/dashboard/AchievementsSection';
import { useSupabaseAuth } from '@/hooks/auth';

const Certificates = () => {
  const { user } = useSupabaseAuth();

  if (!user) {
    return (
      <div className="container mx-auto py-8">
        <div className="text-center py-12">
          <h1 className="text-2xl font-bold mb-4">My Certificates</h1>
          <p className="text-muted-foreground">Please sign in to view your certificates.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto py-8">
      <AchievementsSection />
    </div>
  );
};

export default Certificates;
